import React from 'react';
import { AnswerBlock } from '../../models/message';
import { groupBlocks, splitAtValue } from './groupBlocks';

interface AnswerBlocksProps {
   blocks: AnswerBlock[];
}

const Item: React.FC<{ item: AnswerBlock }> = ({ item }) => {
   const { before, value, after } = splitAtValue(item);
   return (
      <li>
         {before}
         {value && <strong>{value}</strong>}
         {after}
      </li>
   );
};

/**
 * A structured answer set like a directory page: paragraphs, a heading per topic, and item groups on a
 * sub-tile whose key fact (a price, a time) is bold. Everything is React text (escaped), never HTML or Markdown.
 * The answer's photos are never set between its lines: they show as one gallery after it (`AnswerPhotos`).
 */
const AnswerBlocks: React.FC<AnswerBlocksProps> = ({ blocks }) => (
   <div className="cx-answer">
      {groupBlocks(blocks).map((group, index) => {
         if (group.kind === 'list') {
            return (
               <ul key={index}>
                  {group.items.map((item, itemIndex) => (
                     <Item key={itemIndex} item={item} />
                  ))}
               </ul>
            );
         }
         if (group.kind === 'heading') return <h3 key={index}>{group.text}</h3>;
         return <p key={index}>{group.text}</p>;
      })}
   </div>
);

export default AnswerBlocks;
